import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  IUpdateCompanyJobResponseData,
  IUpdateCompanyJobArgs,
} from "./updateCompanyJob.schema";
import { ZealApiSuccessResponse } from "@zeal/common";

type SuccessResponse = ZealApiSuccessResponse<IUpdateCompanyJobResponseData>;

export const updateCompanyJob = (axios: IAxiosInstance) => {
  return async (params: IUpdateCompanyJobArgs) => {
    try {
      const { jobID, ...body } = params;
      const response = await axios.noRetry.patch<SuccessResponse>(
        `/api/company-jobs`,
        { jobID, ...body }
      );
      return response?.data?.data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
